import reducers from './reducers';
import renderPage from '../config/renderPage';
import routes from './routes';
import { INITIAL_BOOKING_ROOT_KEY, pageName } from './constants';
import { preGaCustomMiddleware, postGaCustomMiddleware } from './middleware';

export function start({ el, bootstrap }) {
    renderPage({
        el,
        reducers,
        initialState: {
            ...window.__REDUX_STATE__,
            [INITIAL_BOOKING_ROOT_KEY]: bootstrap,
        },
        routes,
        preGaCustomMiddleware,
        postGaCustomMiddleware,
        pageName,
    });
}
